module.exports = __webpack_public_path__ + "static/media/WheatStage116.8073bca2.PNG";